import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import 'react-toastify/dist/ReactToastify.css';
import App from "./App";
import {
  FirebaseAppProvider,
} from "reactfire";
const firebaseConfig = {
  apiKey: "AIzaSyAwhkUNR_H0QiwwU0Acm_LgooERa7VjdyQ",
  authDomain: "backoffices-accesorios.firebaseapp.com",
  projectId: "backoffices-accesorios",
  storageBucket: "backoffices-accesorios.firebasestorage.app",
  messagingSenderId: "512704461414",
  appId: "1:512704461414:web:de8547ef9b025475350ba7",
  measurementId: "G-MN3PJ0SGP4"
};

ReactDOM.render(
  <FirebaseAppProvider firebaseConfig={firebaseConfig}>
    <App />
  </FirebaseAppProvider>,
  document.getElementById("root")
);
